<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Setting Prodotti
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-text-field
            label="Giorni di scadenza foto prodotti"
            v-model="foto_expiration_days"
            type="number"
            outlined
            prepend-inner-icon="mdi-calendar"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from "lodash";
export default {
  name: "SettingProdotti",
  data() {
    return {
      foto_expiration_days: this.$store.getters.get_foto_expiration_days,
    };
  },
  created() {
    this.debounceDays = _.debounce(this.set_days, 2000);
  },
  watch: {
    foto_expiration_days() {
      this.debounceDays();
    },
  },
  methods: {
    set_days() {
      this.$store.dispatch(
        "imposta_foto_expiration_days",
        this.foto_expiration_days
      );
    },
  },
};
</script>